import React, { useContext } from 'react'
import Usp from 'app/React/Components/Main/Usp'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Usps(props) {
  const {
    currentVariant,
    isDealerConfigurator
  } = useContext(ConfiguratorContext)

  const usps = currentVariant.usps ?? []

  if (usps.length < 1 || isDealerConfigurator) return null

  const usp_elements = usps.map((key, index) => (
    <Usp
      key={index}
      title={usps[index].title}
      value={usps[index].value}
      src={usps[index].image_url}
      alt={usps[index].title}
      showSeperator={index < usps.length - 1}
    />
  ))

  return <div className='car-usps'>{usp_elements}</div>
}
